import React, { useEffect, useState } from 'react';
import { Modal, Box, Typography } from '@mui/material';
import CustomIconButton from 'packages/novous_web/src/common/components/CustomIconButton';
import refresh from "packages/novous_web/src/assets/icons/Refresh.svg";
import arrowUp from "packages/novous_web/src/assets/icons/ArrowBlack.svg";
import arrowDown from "packages/novous_web/src/assets/icons/ArrowDownBlack.svg";
import CustomDropDownInput from 'packages/novous_web/src/common/components/customDropDownInput';
import { useAuth } from 'packages/novous_web/src/authContext/useAuth';
import useAxios from 'packages/novous_web/src/api/useAxios';
import { API_ENDPOINTS } from 'packages/novous_web/src/api/endpoints';
import dayjs from 'dayjs';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import TimeField from 'packages/novous_web/src/common/components/TimeField';
import DateField from 'packages/novous_web/src/common/components/DateField';


interface FilterDataModelProps {
    open: boolean;
    onClose: () => void;
    title?: string;
    subTitle?: string;
    handleFilterSave: (data: any) => void;
    description?: string;
    data?: [{ vehicleId: string, vehicleName: string }];
}

interface VehicleIdOption {
    code: string;
    label: string;
}
let initialDateTime = {
    startDate: null,
    endDate: null,
    startTime: null,
    endTime: null,
}

const FilterVideosModal: React.FC<FilterDataModelProps> = ({
    open,
    onClose,
    title = 'Customise Table',
    subTitle = '',
    handleFilterSave,
    description = 'Choose which sections to display and arrange them the way you like.',
    data
}) => {
    const { user } = useAuth();

    console.log('data', data);

    const {
        data: vehicleNameData,
        error: vehicleNameError,
        loading: vehicleNameLoading,
        fetchData: fetchVehicleNameData,
    } = useAxios<any>(`${API_ENDPOINTS.dashboard.VEHICLE}`, "POST");

    let vehicleNameOptions: VehicleIdOption[] = [];

    if (vehicleNameData) {
        vehicleNameOptions = vehicleNameData.map((item: any) => {
            return {
                code: item.vehicleRegistrationNo,
                label: item.vehicleRegistrationNo
            }
        })
    }





    useEffect(() => {

        if (user?.customer_id) {
            fetchVehicleNameData({ fleetId: user?.customer_id });
        }
    }, [user?.customer_id])


    // Selections
    const [selectedVehicleId, setSelectedVehicleId] = useState<string | null>(null);
    const [selectedVehicleName, setSelectedVehicleName] = useState<string | null>(null);
    const [selectedDateTime, setSelectedDateTime] = useState<{
        startDate: string | null;
        endDate: string | null;
        startTime: string | null;
        endTime: string | null;
    }>(initialDateTime);
    // Expanded/collapsed states
    const [dataTableExpanded, setDataTableExpanded] = useState<boolean>(false);
    const [vehicleNameExpanded, setVehicleNameExpanded] = useState<boolean>(false);
    const [dateTimeExpanded, setDateTimeExpanded] = useState<boolean>(false);
    const [vehicleIdList, setVehicleIdList] = useState([])

    // Handlers
    const handleVehicleIdChange = (newValue: string) => {
        setSelectedVehicleId(newValue);
    };

    const handleVehicleNameChange = (newValue: string) => {
        setSelectedVehicleName(newValue);
    };
    // Handle Date and Time Changes
    const handleDateTimeChange = (value: string | null, field: "startDate" | "endDate" | "startTime" | "endTime") => {
        setSelectedDateTime((prevState) => ({
            ...prevState,
            [field]: value,
        }));
    };

    const toggleDataTableExpanded = () => {
        setDataTableExpanded((prev) => !prev);
    };
    const toggleVehicleNameExpanded = () => {
        setVehicleNameExpanded((prev) => !prev);
    };
    const toggleDateTimeExpanded = () => {
        setDateTimeExpanded((prev) => !prev);
    };

    const handleReset = () => {
        setSelectedVehicleName(null)
        setSelectedVehicleId(null)
        handleFilterSave({
            vehicleId: null,
            vehicleName: null,
        })
        setSelectedDateTime(initialDateTime)
    };

    const handleSave = () => {
        // Perform save logic (send selected filters to parent or API)
        console.log('Filters Applied:', {
            vehicleId: selectedVehicleId,
            vehicleName: selectedVehicleName,
        });
        handleFilterSave({
            vehicleId: selectedVehicleId,
            vehicleName: selectedVehicleName,
            startDate: selectedDateTime.startDate,
            endDate: selectedDateTime.endDate,
            startTime: selectedDateTime.startTime,
            endTime: selectedDateTime.endTime,
        })
        onClose();
    };

    const handleCancel = () => {
        onClose();
    };





    return (
        <Modal
            open={open}
            onClose={handleCancel}
            aria-labelledby="customise-table-title"
            aria-describedby="customise-table-description"
        >
            <Box
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: '70%',
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    p: 4,
                    borderRadius: 2,
                    overflowY: 'auto',
                    height: '80vh'
                }}
            >
                <div className="flex justify-between  h-full flex-col">

                    <div className="flex gap-8 flex-col">
                        {/* Header */}
                        <div className="flex flex-col gap-1">
                            <div className="flex justify-between items-center">
                                <Typography variant="h6">{title} {subTitle}</Typography>
                                <CustomIconButton
                                    text="Clear All"
                                    icon={<img src={refresh} alt="reset" />}
                                    background="transparent"
                                    variant="outlined"
                                    onClick={handleReset}
                                />
                            </div>

                            {description && (
                                <Typography variant="button" fontWeight={400} color="secondary">
                                    {description}
                                </Typography>
                            )}
                        </div>

                        {/* VehicleId section */}
                        <div className="flex flex-col gap-2">
                            <div
                                className="flex justify-between items-center cursor-pointer"
                                onClick={toggleDataTableExpanded}
                            >
                                <Typography variant="body1">Vehicle Registration Number</Typography>

                                <img
                                    src={dataTableExpanded ? arrowUp : arrowDown}
                                    width={24}
                                    height={24}
                                    alt={dataTableExpanded ? 'collapse' : 'expand'}
                                />
                            </div>

                            {dataTableExpanded && (
                                <div className='max-w-[50%]'>

                                    <CustomDropDownInput
                                        options={vehicleNameOptions?.map((item) => ({
                                            value: item?.code,
                                            label: item?.label,
                                        })) || []}
                                        value={selectedVehicleId || ''}
                                        onChange={handleVehicleIdChange}
                                        placeholder="Select Registration No."
                                    />
                                </div>
                            )}
                        </div>

                        {/* VehicleName Type section */}
                        {/* <div className="flex flex-col gap-2">
                            <div
                                className="flex justify-between items-center cursor-pointer"
                                onClick={toggleVehicleNameExpanded}
                            >
                                <Typography variant="body1">Vehicle Name</Typography>

                                <img
                                    src={vehicleNameExpanded ? arrowUp : arrowDown}
                                    width={24}
                                    height={24}
                                    alt={vehicleNameExpanded ? 'collapse' : 'expand'}
                                />
                            </div>

                            {vehicleNameExpanded && (
                                <div className='max-w-[50%]'>

                                    <CustomDropDownInput
                                        options={data?.map((item) => ({
                                            value: item?.vehicleName || "N/A",
                                            label: item?.vehicleName || "N/A",
                                        })) || []}
                                        value={selectedVehicleName || ''}
                                        onChange={handleVehicleNameChange}
                                        placeholder="Select Vehicle Name"
                                    />
                                </div>


                            )}
                        </div> */}
                        {/* Date & Time section */}
                        <div className="flex flex-col gap-2">
                            <div
                                className="flex justify-between items-center cursor-pointer"
                                onClick={toggleDateTimeExpanded}
                            >
                                <Typography variant="body1">Date & Time</Typography>

                                <img
                                    src={dateTimeExpanded ? arrowUp : arrowDown}
                                    width={24}
                                    height={24}
                                    alt={vehicleNameExpanded ? 'collapse' : 'expand'}
                                />
                            </div>

                            {dateTimeExpanded && (
                                <div >
                                    <div className="flex gap-4 sm:flex-row flex-col">
                                        <div className="flex-1">
                                            <DateField label="Start Date" name="startDate"
                                                value={selectedDateTime.startDate}
                                                onChange={(v) => handleDateTimeChange(v, "startDate")}
                                                maxDate={dayjs().format("MM/DD/YYYY")}
                                            />
                                        </div>
                                        <div className="flex-1">
                                            <DateField label="End Date" name="endDate"
                                                value={selectedDateTime?.endDate}
                                                onChange={(v) => handleDateTimeChange(v, "endDate")}
                                                maxDate={dayjs().format("MM/DD/YYYY")} />
                                        </div>
                                    </div>
                                    <div className="flex gap-4 sm:flex-row flex-col mt-2">
                                        <div className="flex-1">
                                            <TimeField label="Start Time" name="startTime"
                                                value={selectedDateTime.startTime}
                                                onChange={(v) => handleDateTimeChange(v, "startTime")}
                                            />
                                        </div>
                                        <div className="flex-1">
                                            <TimeField label="End Time" name="endTime"
                                                value={selectedDateTime?.endTime}
                                                onChange={(v) => handleDateTimeChange(v, "endTime")} />
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Action Buttons */}
                    <div className="flex gap-2 mt-4 items-center  justify-between">
                        <CustomIconButton
                            text="Cancel"
                            background="transparent"
                            outline
                            padding="0px"
                            variant="outlined"
                            onClick={handleCancel}
                        />
                        <CustomIconButton
                            text="Apply"
                            outline
                            padding="0px"
                            variant="contained"
                            onClick={handleSave}
                        />
                    </div>
                </div>
            </Box>
        </Modal>
    );
};

export default FilterVideosModal;


